import { sortBy } from 'lodash';

export function useSortTranches(
  tranches: Array<{
    _id: string;
    fundName: string;
    firmId: { firmName: string };
  }> = [],
) {
  const mappedTranche = tranches.map((x) => ({
    _id: x._id,
    label: `${x?.firmId?.firmName ?? ''} ${x?.fundName}`.trim(),
  }));
  const sortedTranche = sortBy(mappedTranche, (x) => x.label.toLowerCase());
  return sortedTranche;
}
